import { $api } from '@/services/api/client'

export interface CategoryChip {
  id: string
  chipName: string
  activeColor: string
  inactiveColor: string
}

// TODO: remove hardcoded data
export const categoryChips: CategoryChip[] = [
  {
    id: '1',
    chipName: 'Environment',
    activeColor: 'bg-cat-environment border border-cat-environment',
    inactiveColor: 'border border-cat-environment',
  },
  {
    id: '2',
    chipName: 'Social',
    activeColor: 'border border-cat-social bg-cat-social',
    inactiveColor: 'border border-cat-social',
  },
  {
    id: '5',
    chipName: 'Inno&Tech',
    activeColor: 'border border-cat-technology bg-cat-technology',
    inactiveColor: 'border border-cat-technology',
  },
  {
    id: '10',
    chipName: 'Ai',
    activeColor: 'border border-cat-ai bg-cat-ai',
    inactiveColor: 'border border-cat-ai',
  },
  {
    id: '15',
    chipName: 'Business',
    activeColor: 'border border-cat-business bg-cat-business',
    inactiveColor: 'border border-cat-business',
  },
  {
    id: '20',
    chipName: 'Marketing',
    activeColor: 'border border-cat-marketing bg-cat-marketing',
    inactiveColor: 'border border-cat-marketing',
  },
  {
    id: '25',
    chipName: 'Content',
    activeColor: 'border border-cat-content bg-cat-content',
    inactiveColor: 'border border-cat-content',
  },
  {
    id: '30',
    chipName: 'Film',
    activeColor: 'border border-cat-film bg-cat-film',
    inactiveColor: 'border border-cat-film',
  },
  {
    id: '35',
    chipName: 'Talent',
    activeColor: 'border border-cat-talent bg-cat-talent',
    inactiveColor: 'border border-cat-talent',
  },
  {
    id: '40',
    chipName: 'Sport',
    activeColor: 'border border-cat-sport bg-cat-sport',
    inactiveColor: 'border border-cat-sport',
  },
  {
    id: '45',
    chipName: 'Music & Song',
    activeColor: 'border border-cat-music bg-cat-music',
    inactiveColor: 'border border-cat-music',
  },
  {
    id: '50',
    chipName: 'Dance',
    activeColor: 'border border-cat-dance bg-cat-dance',
    inactiveColor: 'border border-cat-dance',
  },
  {
    id: '55',
    chipName: 'Cultural',
    activeColor: 'bg-cat-dance border border-cat-dance',
    inactiveColor: 'border border-cat-dance',
  },
  {
    id: '60',
    chipName: 'Art',
    activeColor: 'border border-cat-art bg-cat-art',
    inactiveColor: 'border border-cat-art',
  },
  {
    id: '65',
    chipName: 'Design',
    activeColor: 'border border-cat-design bg-cat-design',
    inactiveColor: 'border border-cat-design',
  },
  {
    id: '70',
    chipName: 'Idea',
    activeColor: 'border border-cat-idea bg-cat-idea',
    inactiveColor: 'border border-cat-idea',
  },
  {
    id: '75',
    chipName: 'Fashion',
    activeColor: 'border border-cat-fashion bg-cat-fashion',
    inactiveColor: 'border border-cat-fashion',
  },
  {
    id: '80',
    chipName: 'Photo',
    activeColor: 'border border-cat-photo bg-cat-photo',
    inactiveColor: 'border border-cat-photo',
  },
  {
    id: '85',
    chipName: 'Architecture',
    activeColor: 'border border-cat-architecture bg-cat-architecture',
    inactiveColor: 'border border-cat-architecture',
  },
  {
    id: '90',
    chipName: 'Linguistic',
    activeColor: 'border border-cat-linguistic bg-cat-linguistic',
    inactiveColor: 'border border-cat-linguistic',
  },
  {
    id: '95',
    chipName: 'Academic',
    activeColor: 'border border-cat-academic bg-cat-academic',
    inactiveColor: 'border border-cat-academic',
  },
  {
    id: '100',
    chipName: 'Communication',
    activeColor: 'border border-cat-communication bg-cat-communication',
    inactiveColor: 'border border-cat-communication',
  },
  {
    id: '105',
    chipName: 'Logo',
    activeColor: 'border border-cat-logo bg-cat-logo',
    inactiveColor: 'border border-cat-logo',
  },
  {
    id: '999',
    chipName: 'Other',
    activeColor: 'border border-zinc-900 bg-zinc-900 text-white',
    inactiveColor: 'border border-zinc-900',
  },
]

export function useCategories() {
  const { data, error, isLoading } = $api.useQuery('get', '/category')

  return {
    categories: data?.data,
    isLoading,
    error,
  }
}
